import { render, staticRenderFns } from "./AdminSetting.vue?vue&type=template&id=67238f86"
import script from "./AdminSetting.vue?vue&type=script&lang=js"
export * from "./AdminSetting.vue?vue&type=script&lang=js"
import style0 from "./AdminSetting.vue?vue&type=style&index=0&id=67238f86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports